import { createElement as rc, useMemo } from 'react';
import { styled } from 'lib_ui-primitives';
import AbstractMenuButton from '../_abstractComponent/MenuButton';
import useActiveRecord from '../../hooks/useActiveRecord';
import useFormMachine from '../../hooks/useFormMachine';
import PropTypes from 'prop-types';

const FormMenuButton = styled(AbstractMenuButton)``;
FormMenuButton.displayName = 'FormElementMenuButton';

// @ts-ignore
/** @typedef {import('../../hooks/useFormMachine').FormContext} FormContext */

export default function MenuButton(props) {
    const {
        hNode,
        children,
        currentRoute,
        ...otherProps
    } = props;

    const activeRecord = useActiveRecord();
    /** @type {FormContext} */
    const formContext = useFormMachine(hNode);
    const record = formContext.newRecord || activeRecord.record;
    const namespace = hNode.namespace || activeRecord.namespace;
    const relation = hNode.relation || activeRecord.relation;
    const type = hNode.type || activeRecord.type;

    const actionPayload = useMemo(() => {
        return {
            record,
            activeRecord,
            hNodeId: hNode.id
        };
    }, [hNode.id, activeRecord, record]);

    const enrichedHNode = useMemo(() => ({
        namespace,
        relation,
        type,
        ...hNode
    }), [namespace, relation, type, hNode]);

    return rc(FormMenuButton, {
        hNode: enrichedHNode,
        actionPayload,
        children,
        currentRoute,
        icons: hNode.icons,
        ...otherProps
    });
}

MenuButton.propTypes = {
    hNode: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        iconName: PropTypes.string,
        buttonStyle: PropTypes.string,
        style: PropTypes.string,
        namespace: PropTypes.string,
        relation: PropTypes.string,
        icons: PropTypes.bool
    }).isRequired,
    children: PropTypes.node,
    currentRoute: PropTypes.string
};
